import { ApiEndpointBuilder } from '@/services/api/types';

const declineInvitation = (builder: ApiEndpointBuilder) => {
    return builder.mutation<boolean, { invitationId: string | undefined, code: string | null }>({
        query: ({ invitationId, code }) => ({
            url: `/invitations/${invitationId}/decline?code=${code}`,
            method: 'PUT',
        }),
    });
};

export default declineInvitation;
